// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__19gXj","spinner":"styles_spinner__325IY","spin":"styles_spin__2WPJc","name":"styles_name___CNdN","size":"styles_size__3sAe_"};